import apiClient from '../../../services/apiClient';
import cacheService from '../../../services/cacheService';
import { shutdownEventStream } from '../../event-stream';
import windowService from '../../../services/windowService';
import { shutdownIntercom } from '../../analytics/adapters/intercomAdapter';
import { saveState } from './saveUserState';
import { clearStoredUser } from './userStorage';
import { forgetJwt, getJwt, validateJwt } from '../../../services/jwt';

export function clearSessionState() {
  cacheService.removeAll();
  shutdownEventStream();
  shutdownIntercom();

  try {
    clearStoredUser();
    window.sessionStorage.removeItem('lastAddMaterialSelections');
    window.localStorage.removeItem('receivedEvents');
  } catch {
    /* ignore */
  }
}

function finalizeLocalLogout() {
  try {
    forgetJwt();
    clearStoredUser();
  } catch {
    /* ignore */
  }
}

export function hasStoredSession() {
  try {
    return validateJwt(getJwt());
  } catch {
    return false;
  }
}

function getRouteQueryFromUrl(redirectURL?: string): string {
  if (!redirectURL) {
    return '';
  }
  const hash = redirectURL;
  const path = hash.startsWith('#') ? hash.substring(1) : hash;
  const route = path.startsWith('/') ? path.substring(1) : path;
  return route;
}

function getLoginPath(redirectURL?: string): string {
  return `/login${redirectURL ? `?route=${encodeURIComponent(redirectURL)}` : ''}`;
}

function finishLogout(redirectURL?: string) {
  clearSessionState();
  finalizeLocalLogout();

  const um = window.getUserManager?.();
  if (!um) {
    windowService.redirectTo(getLoginPath(redirectURL));
    return;
  }

  um.getUser()
    .then(user => {
      if (user) {
        saveState(redirectURL);
        return um.signoutRedirect().catch(() => {
          windowService.redirectTo(getLoginPath(redirectURL));
        });
      }
      windowService.redirectTo(getLoginPath(redirectURL));
    })
    .catch(() => {
      windowService.redirectTo(getLoginPath(redirectURL));
    });
}

export function logout(redirectURL?: string) {
  clearSessionState();

  if (hasStoredSession()) {
    const loginPath = getRouteQueryFromUrl(redirectURL);
    apiClient.get('/v1/logout').then(
      () => finishLogout(loginPath),
      () => finishLogout(loginPath)
    );
  } else {
    finishLogout(getRouteQueryFromUrl(redirectURL || window.location.hash));
  }
}
